import { Checkbox, FormControlLabel, Stack } from "@mui/material";
import { paperGoodsIssueBusiness } from "api/bussiness/paper-material/paper-goods-issue";
import { downloadFile } from "commons/ultilities";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { Dayjs } from "dayjs";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { DateRange } from "share-components/atomics/date-range";
import { ExportExcelDialog } from "share-components/mui-wrap/dialog/export-excel-dialog";

export const ExportExcel = observer(() => {
  const {
    paperInventoryManagement: {
      paperGoodsIssueStore: {
        excelParams: {
          issueDateRangeFilter: {
            fromAsDayJs: fromIssueAsDayJs,
            from: fromIssue,
            to: toIssue,
            toAsDayJs: toIssueAsDayJs,
            setProp: setIssueDateRange,
          },
          showZeroQuantity,
          setProp: setExcelParamsProp,
        },
        openExportExcel,
        setProp,
      },
    },
  } = useStores();
  const handleClose = () => {
    setProp("openExportExcel", false);
  };

  const fromIssueDateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setIssueDateRange("from", value ? value.toString() : null);
    },
    [setIssueDateRange],
  );

  const toIssueDateChangedHandler = useCallback(
    (value?: Dayjs | null) => {
      setIssueDateRange("to", value ? value.toString() : null);
    },
    [setIssueDateRange],
  );

  const exportExcel = useCallback(async () => {
    try {
      const res = await paperGoodsIssueBusiness.exportExcel({
        fromIssueDate:
          fromIssueAsDayJs?.isValid() && fromIssue ? fromIssue : "",
        toIssueDate: toIssueAsDayJs?.isValid() && toIssue ? toIssue : "",
        showZeroQuantity: showZeroQuantity,
      });
      downloadFile(
        res,
        "Xuat_Kho_Giay_Tu_" +
          (dateTimeDisplay(fromIssue) || "") +
          "_den_" +
          (dateTimeDisplay(toIssue) || "") +
          ".xlsx",
      );
    } finally {
    }
  }, [fromIssue, fromIssueAsDayJs, toIssue, toIssueAsDayJs, showZeroQuantity]);

  const showZeroQuantityHandler = useCallback(
    async (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      setExcelParamsProp("showZeroQuantity", checked);
    },
    [setExcelParamsProp],
  );

  return (
    <ExportExcelDialog
      open={openExportExcel}
      handleClose={handleClose}
      exportBtnDisabled={false}
      exportHandler={exportExcel}
    >
      <Stack direction={"column"} spacing={2}>
        <Stack
          direction={"row"}
          alignItems={"center"}
          spacing={1}
          sx={{ paddingTop: 1 }}
        >
          <DateRange
            label={"Ngày xuất kho"}
            fromDate={fromIssueAsDayJs}
            toDate={toIssueAsDayJs}
            onFromDateChanged={fromIssueDateChangedHandler}
            onToDateChanged={toIssueDateChangedHandler}
          ></DateRange>
        </Stack>
        <Stack>
          <FormControlLabel
            control={
              <Checkbox
                checked={showZeroQuantity}
                onChange={showZeroQuantityHandler}
              />
            }
            label="Gồm tồn bằng 0"
          />
        </Stack>
      </Stack>
    </ExportExcelDialog>
  );
});
